module.exports = __webpack_public_path__ + "img/Image_4.5271802b.jpg";